import React, { memo } from 'react'
import styles from './PublicLayoutProducts.module.scss'
import Header from './components/Header'
import { Outlet } from 'react-router-dom'

type Props = {}

const PublicLayoutProducts: React.FC<Props> = memo((props: Props) => {
    return (
        <>
            <Header />
            <div className={styles.container}>
                <Outlet />
            </div>
        </>
    )
})

export default PublicLayoutProducts